import { Component, Input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-section',
  standalone: true,
  imports: [LucideAngularModule, ButtonModule],
  templateUrl: './section.component.html',
})
export class SectionComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() lucidIconRef?: string;
  colapsed: boolean = true;
}
